module.exports = __webpack_public_path__ + "media/images/icons/filled/usb-9611c367632e779e8e794bed99d6a3bd.svg";